import React from 'react';
import { Navigate } from 'react-router-dom';
import { v4 } from 'uuid';
import { IPortal, useStore } from '@mcn-platform/models';
import ItemEdit from 'components/item/ItemEdit';

const EditPortal = ({ item, setOpen }: { item: IPortal & { id?: string }; setOpen: (v: boolean) => void }) => {
  const store = useStore();

  if (!item.id) {
    return (
      <ItemEdit
        modelName="portal"
        item={item}
        formConfig={['name', 'publicName', 'description', 'type']}
        handleSubmit={(newValues: Record<string, unknown>) => {
          store.add('library', {
            name: `${newValues.name} Portal Library`,
            id: v4(),
            organization: store.currentOrganization?.id,
          })
            .then((library) => {
              store.add('portal', {
                ...newValues,
                defaultLibrary: library,
                id: v4(),
                organization: store.currentOrganization?.id,
              });
            })
            .then(() => {
              store.clearCachedList('portal');
              setOpen(false);
            });
        }}
      />
    );
  }

  store.setCurrentPortal(item);
  return <Navigate to="../details" />;
};

export default EditPortal;
